import * as React from 'react';

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  radioColor?: string;
}

const Radio: React.FC<RadioProps> = ({
  label,
  className,
  radioColor = '',
  onClick,
  disabled,
  ...props
}) => {
  const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else if (onClick) {
      onClick(e);
    }
  };

  return (
    <label className="flex items-center gap-2 cursor-pointer">
      <div className="relative">
        <input
          type="radio"
          className="peer sr-only"
          disabled={disabled}
          onClick={handleClick}
          {...props}
        />
        <div
          className={`${radioColor ? radioColor : ''} w-5 h-5 border-2 border-red-600 rounded-full peer-checked:border-red-600 peer-checked:before:absolute peer-checked:before:content-[''] peer-checked:before:w-3 peer-checked:before:h-3 peer-checked:before:bg-red-600 peer-checked:before:rounded-full peer-checked:before:top-1/2 peer-checked:before:left-1/2 peer-checked:before:-translate-x-1/2 peer-checked:before:-translate-y-1/2 peer-disabled:border-gray-300 peer-disabled:bg-gray-100 peer-disabled:before:bg-gray-400`}
        />
      </div>
      {label && <span className="text-sm">{label}</span>}
    </label>
  );
};

export default Radio;
